































































































































































































import { Component } from 'vue-property-decorator';
import Mixin from '@/mixin';
import authModule from '@/store/modules/common/auth.module';
import VAvatar from '@/components/avatar/VAvatar.vue';
import authService from '@/services/common/auth.service';
import { validationMixin, Vuelidate } from 'vuelidate';
import { profileValidator, TUser } from '@/config/validation/profile-validator';
import messageModule from '@/store/modules/common/message.module';
import { MessageType } from '@/config/enum';

@Component({
  name: 'AdminInfo',
  mixins: [validationMixin],
  validations: profileValidator,
  components: { VAvatar }
})
export default class AdminInfo extends Mixin {
  get vUser() {
    return (this.$v as Vuelidate<TUser>).user;
  }

  public openPhoto() {
    document.getElementById('profileChangeAvatar')?.click();
  }

  public async handleFileChange(event: any) {
    const files: FileList = event.target.files;
    const validImageTypes = ['image/gif', 'image/jpeg', 'image/png'];
    if (files && validImageTypes.includes(files[0].type)) {
      await authService.changeAvatar(files[0]);
      await authModule.getAdminInfo();
    } else {
      await messageModule.showMessage({
        message: 'Please choose image type (.png/.jpg/.gif).',
        type: MessageType.danger
      });
    }
  }

  get allowSubmit() {
    return !(this.vUser?.$error || this.vUser?.$invalid);
  }

  public updateAccount() {
    this.vUser?.$touch();
    if (this.allowSubmit && this.user) {
      authService.updateAdminInfo(this.user).then(() => {
        messageModule.showMessage({
          message: `User ${this.user?.firstName} ${this.user?.lastName} has been updated successfully`,
          type: MessageType.info
        });
      });
    }
  }

  get user() {
    return authModule.user;
  }

  mounted() {
    authModule.getAdminInfo();
  }
}
